import { render } from "./EditAttendance.vue?vue&type=template&id=06fb3022&scoped=true&ts=true"
import script from "./EditAttendance.vue?vue&type=script&lang=ts"
export * from "./EditAttendance.vue?vue&type=script&lang=ts"

import "./EditAttendance.vue?vue&type=style&index=0&id=06fb3022&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06fb3022"]])

export default __exports__